function toggleTextInSection(event, sectionId) {
    event.preventDefault();
    const sectionElement = document.getElementById(sectionId);
    const buttonTextOff = sectionElement.getElementsByClassName('text-toggle-off')[0];
    const buttonTextOn = sectionElement.getElementsByClassName('text-toggle-on')[0];
    const shortText = sectionElement.getElementsByClassName('short-text')[0];
    const fullText = sectionElement.getElementsByClassName('full-text')[0];
    
    if (buttonTextOff.style.display === 'none') {
        buttonTextOff.style.display = 'block';
        buttonTextOn.style.display = 'none';
    } else {
        buttonTextOff.style.display = 'none';
        buttonTextOn.style.display = 'block';
    }

    if (fullText.style.display === 'none') {
        fullText.style.display = 'block';
        shortText.style.display = 'none';
    } else {
        fullText.style.display = 'none';
        shortText.style.display = 'block';
    }
};